export var formatExperience = function (y, m, separator) {
    if (separator === void 0) { separator = ''; }
    var year = parseFloat(y);
    var month = parseFloat(m);
    if (year % 1 != 0) {
        // checking if the number is decimal
        year = 0;
    }
    if (month % 1 != 0) {
        // checking if the number is decimal
        month = 0;
    }
    if (year < 0)
        year = 0;
    if (month < 0)
        month = 0;
    var yearLabel = '';
    var monthLabel = '';
    if (year && year > 1) {
        yearLabel = 'Years';
    }
    else {
        yearLabel = 'Year';
    }
    if (month && month > 1) {
        monthLabel = 'Months';
    }
    else {
        monthLabel = 'Month';
    }
    var output = '';
    if (year && month) {
        output = "".concat(year, " ").concat(yearLabel).concat(separator, " ").concat(month, " ").concat(monthLabel);
    }
    else if (year) {
        output = "".concat(year, " ").concat(yearLabel);
    }
    else if (month) {
        output = "".concat(month, " ").concat(monthLabel);
    }
    else {
        output = '';
    }
    return output;
};
